import { useEffect, useState } from "react";

export function useCountdownTimer(startTime, endTime) {
  const [timeLeft, setTimeLeft] = useState({
    hours: "00",
    minutes: "00",
    seconds: "00",
  });
  const [isActive, setIsActive] = useState(false);
  const [hasEnded, setHasEnded] = useState(false);
  const [yetToStart, setYetToStart] = useState(false);

  useEffect(() => {
    const timer = setInterval(() => {
      const now = new Date();
      const currentTime =
        now.getHours() * 3600 + now.getMinutes() * 60 + now.getSeconds();

      // Convert start_time and end_time from "HH:MM:SS" to seconds
      const [startHour, startMin, startSec] = startTime.split(":").map(Number);
      const [endHour, endMin, endSec] = endTime.split(":").map(Number);

      const startTimeInSeconds = startHour * 3600 + startMin * 60 + startSec;
      const endTimeInSeconds = endHour * 3600 + endMin * 60 + endSec;

      // Check if current time is within the active period
      if (
        currentTime >= startTimeInSeconds &&
        currentTime <= endTimeInSeconds
      ) {
        setIsActive(true);
        setHasEnded(false);
        setYetToStart(false);

        // Calculate remaining time until end_time
        const remainingSeconds = endTimeInSeconds - currentTime;

        const hours = Math.floor(remainingSeconds / 3600);
        const minutes = Math.floor((remainingSeconds % 3600) / 60);
        const seconds = remainingSeconds % 60;

        setTimeLeft({
          hours: hours.toString().padStart(2, "0"),
          minutes: minutes.toString().padStart(2, "0"),
          seconds: seconds.toString().padStart(2, "0"),
        });
      } else if (currentTime > endTimeInSeconds) {
        // Time period has ended
        setIsActive(false);
        setHasEnded(true);
        setYetToStart(false);
        setTimeLeft({ hours: "00", minutes: "00", seconds: "00" });
      } else {
        // Time period hasn't started yet - countdown to start time
        setIsActive(false);
        setHasEnded(false);
        setYetToStart(true);

        // const timeUntilStart = startTimeInSeconds - currentTime;
        // const hours = Math.floor(timeUntilStart / 3600);
        // const minutes = Math.floor((timeUntilStart % 3600) / 60);
        // const seconds = timeUntilStart % 60;

        // setTimeLeft({
        //   hours: hours.toString().padStart(2, "0"),
        //   minutes: minutes.toString().padStart(2, "0"),
        //   seconds: seconds.toString().padStart(2, "0"),
        // });
      }
    }, 1000);

    return () => clearInterval(timer);
  }, [startTime, endTime]);

  return { timeLeft, isActive, hasEnded, yetToStart };
}
